export default __webpack_public_path__ + "static/media/source-logo-ethos.cf9c336a.png";